import { Hit } from "instantsearch.js";

import {
  WorkspaceMemberAssistantsQuery,
  WorkspaceScheduleJobsQuery,
  WorkspaceSubscriptionQuery,
  WorkspaceGroupQuery,
  WorkspaceClientStatisticsQuery,
  ClientStatisticQuery,
  LoginMutation,
} from "@/graphql";
import { NonNullableArrayItem } from "@/utils/types";

// ==================
// Workspace
// ==================

export const DEFAULT_PERSONAL_WOKSPACE: Workspace = {
  id: "-1",
  urlSlug: "",
  name: "Personal",
  active: true,
};

export type LoginWorkspace = NonNullableArrayItem<
  NonNullable<LoginMutation["login"]>["workspaces"]
>;

export interface Workspace {
  id: string;
  urlSlug: string;
  name: string;
  active?: boolean;
  analyticsEnabled?: boolean;
  logo?: string | null;
  programsEnabled?: boolean;
  roleplaysEnabled?: boolean;
}

// ==================
// Member
// ==================

export type StatsMember = NonNullableArrayItem<
  NonNullable<
    WorkspaceClientStatisticsQuery["workspaceClientStatistics"]
  >["data"]
>;

// ==================
// Client
// ==================

export type Client = NonNullableArrayItem<
  NonNullable<ClientStatisticQuery["clientStatistics"]>["data"]
>;

// ==================
// Assistants
// ==================

export type MainAssistant = NonNullable<
  NonNullableArrayItem<
    NonNullable<WorkspaceMemberAssistantsQuery["workspaceMember"]>["assistants"]
  >["assistant"]
>;

// ==================
// Group
// ==================

export type WorkspaceGroup = NonNullable<WorkspaceGroupQuery["workspaceGroup"]>;

// ==================
// Tables
// ==================

export type ClientTableField =
  | "name"
  | "next_meeting_event_at"
  | "last_meeting_event_at"
  | "recent_review_create_at"
  | "messages_created_at"
  | "workspace_name"
  | "coach_name"
  | "created_at";

export type MemberTableField =
  | "name"
  | "balance"
  | "groups"
  | "email"
  | "checkbox"
  | "actions";

// ==================
// Misc
// ==================

export type WorkspaceScheduleJob = NonNullableArrayItem<
  WorkspaceScheduleJobsQuery["scheduledJobs"]
>;

export interface WorkspaceInvitationBatch {
  coaches?: Hit[];
  group?: { id: string } | null;
  workspaceInvitations?: { email: string }[];
  credit?: string | null;
  schedulingDetail?: {
    isSchedule: boolean;
    scheduleAt?: string;
    scheduledJobId?: string;
  };
}

export type Subscription = NonNullable<
  NonNullable<WorkspaceSubscriptionQuery["currentWorkspace"]>["subscription"]
>;

export type OnCheckHandler = ({
  checked,
  member,
  isCheckAll,
}: {
  checked: boolean;
  member?: StatsMember;
  isCheckAll?: boolean;
}) => void;
